import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components';
import type { AutomationControlView, AutomationMode } from '@/shared/api/types/automationControl';

export function AutomationAssignment({
  view,
  pending,
  onSave,
}: {
  view: AutomationControlView;
  pending: boolean;
  onSave: (ownerInstallationId: string | null, mode: AutomationMode) => void;
}) {
  const { t } = useTranslation('automation');
  const [owner, setOwner] = useState(view.control.ownerInstallationId ?? '');
  const [mode, setMode] = useState<AutomationMode>(view.control.mode);
  return (
    <details className="text-ink-soft mt-2 text-sm">
      <summary className="focus-visible:ring-sage min-h-11 cursor-pointer py-3 focus-visible:ring-2">
        {t('configure')}
      </summary>
      <div className="@lg:grid-cols-2 grid grid-cols-1 items-end gap-2 pb-2">
        <label className="min-w-0 flex-1">
          {t('owner')}
          <select
            value={owner}
            onChange={(e) => setOwner(e.target.value)}
            disabled={pending}
            className="border-line bg-card text-ink mt-1 min-h-11 w-full rounded-md border px-2"
          >
            <option value="">{t('none')}</option>
            {view.owners
              .filter((x) => x.canAssign)
              .map((x) => (
                <option key={x.installationId} value={x.installationId}>
                  {x.name}
                </option>
              ))}
          </select>
        </label>
        <label className="min-w-0 flex-1">
          {t('mode')}
          <select
            value={mode}
            onChange={(e) => setMode(e.target.value as AutomationMode)}
            disabled={pending}
            className="border-line bg-card text-ink mt-1 min-h-11 w-full rounded-md border px-2"
          >
            {(['Disabled', 'Copilot', 'Shadow', 'Autopilot'] as const).map((x) => (
              <option key={x} value={x}>
                {t(x)}
              </option>
            ))}
          </select>
        </label>
        <Button
          type="button"
          variant="brand"
          className="@lg:col-span-2 min-h-11"
          disabled={pending || (!owner && mode !== 'Disabled')}
          onClick={() => onSave(owner || null, mode)}
        >
          {t('save')}
        </Button>
      </div>
    </details>
  );
}
